import netsVoicemailList from './nets-voicemail-list';
import netsVoicemailMenu from './components/voicemail-menu/nets-voicemail-menu';
import moduleConfig from './module-config';

export default angular
  .module('app.voicemailList', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsVoicemailList', netsVoicemailList)
  .component('netsVoicemailMenu', netsVoicemailMenu);
